import React, { useState } from 'react';
import { t } from "i18next";

import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { Select } from "@/shared/components/organisms/Select";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import InputRadio from "@/shared/components/atoms/InputRadio";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import { InputsCard } from "@/shared/components/organisms/InputsCard";

const DialogAssignFee = ({
  open,
  setOpen,
  titleDialog,
  textButtonSubmit,
  openDialog,
  formSelect,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  titleDialog: string;
  textButtonSubmit: string;
  openDialog: () => void;
  formSelect: number;
}) => {

  const [selectedOptionRenewFee, setSelectedOptionRenewFee] = useState("card");

  // Función para manejar el cambio del radio
  const handleRadioChangeRenewFee = (event) => {
    setSelectedOptionRenewFee(event.target.value);
  };

  // SELECT DE TIPO DE PAGO
  const optionsBaja = [
    { id: 1, name: "Baja 1" },
    { id: 2, name: "Baja 2" },
  ];
  const [selectedBaja, setSelectedBaja] = useState(optionsBaja[0]);
  // SELECT DE PAIS
  const optionsPais = [
    { id: 1, name: "Spain" },
    { id: 2, name: "Andorra" },
    { id: 3, name: "Mexico" },
    { id: 4, name: "Colombia" },
  ];
  const [selectPais, setSelectPais] = useState(optionsPais[0]);
  //SELECT TYPE PAYMENT
  const optionsTypePayment = [
    { id: 1, name: t("direct_debit.views.payment_manual_1") },
    { id: 2, name: t("direct_debit.views.payment_manual_2") },
    { id: 3, name: t("direct_debit.views.payment_manual_3") },
    { id: 4, name: t("direct_debit.views.payment_manual_4") },
    { id: 5, name: t("direct_debit.views.payment_manual_5") },
  ];
  const [selectTypePayment, setSelectTypePayment] = useState(
    optionsTypePayment[0],
  );
  //SELECT HACIENDA
  const optionsHacienda = [
    { id: 1, name: t("gti.views.not_generate") },
    { id: 2, name: t("accounting.views.ticket") },
    { id: 3, name: t("gti.views.invoice") },
  ];
  const [selectHacienda, setSelectHacienda] = useState(optionsHacienda[0]);
  //SELECT TYPE ID
  const optionsTypeId = [
    { id: 1, name: t("store.views.cedula_fisica") },
    { id: 2, name: t("store.views.cedula_juridica") },
    { id: 3, name: t("store.views.dimex") },
    { id: 4, name: t("store.views.nite") },
    { id: 5, name: t("store.views.extranjera") },
  ];
  const [selectTypeId, setSelectTypeId] = useState(optionsTypeId[0]);
  

  const handleDateChange = (startDate: Date, endDate: Date) => {
    console.log(
      `Selected range: ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`,
    );
  };

  return (
    <DialogCreate
      open={open}
      setOpen={setOpen}
      tittle={titleDialog}
      tittleButtonCreate={textButtonSubmit}
      tittleButtonCancel={t("general.cancel")}
      OnclickCreate={() => {}}
      OnclickCancel={openDialog}
    >
     
    </DialogCreate>
  );
}

export default DialogAssignFee;